export default {
	getInitialState() {
		return {
			current: -1
		};
	},

	activateItem(ind) {
		let index = ind;
		if (index === 'next') {
			index = this.state.current + 1;
		} else if (index === 'previous') {
			index = this.state.current - 1;
		}
		if (index < 0) {
			index = this.props.data.results.length;
		} else if (index > this.props.data.results.length) {
			index = 0;
		}
		this.setState({current: index});
	},

	goItem() {
		const result = this.props.data.results[this.state.current];
		window.location.href = result ? result.url : this.props.data.url;
	}
};
